import React, {useState, useMemo} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil';
import { alarmModal1Text } from '../atom/ModalAtom';
import { ApiService } from '../api';
import { Config } from '../config';
import { accessTokenState, refreshTokenState, expireState, updateTimeState } from '../atom/TokenAtom';

const Login = () => {
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState);
    const setRefreshToken = useSetRecoilState(refreshTokenState);
    const setExpire = useSetRecoilState(expireState);
    const setAlarmText = useSetRecoilState(alarmModal1Text);
    const [updateTime, setUpdateTime] = useRecoilState(updateTimeState);

    const navigate = useNavigate();

    const [id, setId] = useState('');
    const [pw, setPw] = useState('');
    const api = useMemo(() => new ApiService(), []);

    //로그인
    const login = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (id === '' || pw === '') return setAlarmText("빈 칸을 확인해 주세요.");
        const token = await api.login(id, pw);
        if (token === null) {
            setAlarmText("계정 정보가 올바르지 않습니다.\n확인 후 다시 시도하세요.");
        } else {
            console.log(token);
            setAccessToken(token.accessToken);
            setRefreshToken(token.refreshToken);
            setExpire(token.expire);
            setUpdateTime(Date.now());
            navigate('/certification');
        }
    }
    const onChangeId = (str: string) => {
        setId(str);
    }
    const onChangePw = (str: string) => {
        setPw(str);
    }

    return (
        <>
            <Wrap className="flex aic jcc">
                <div className="log-box flex">
                    <div className="img-area flex aic jcc">
                        <span className="img-box">
                            <img src="/img/logo_ico.svg" alt=""/>
                        </span>
                    </div>
                    <div className="field-box flex fdc aic jcc">
                        <span className="logo-box img-box">
                            <img src="/img/log_logo.svg" alt=""/>
                        </span>
                        <form onSubmit={login}>
                            <div className="input-box flex fdc">
                                <input type="id" placeholder="아이디" onChange={(e) => onChangeId(e.currentTarget.value)}/>
                                <input type="password" placeholder="비밀번호" onChange={(e) => onChangePw(e.currentTarget.value)}/>
                            </div>
                            <button type='submit' className="log-btn">로그인</button>
                        </form>
                    </div>
                </div>
            </Wrap>
        </>
    );
};

export default Login;

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
    background: #f1f1f1;
    .log-box {
        width: 992px;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
        .img-area {
            width: 50%;
            background: #F1FDFE;
            > img {
                width: 320px;
            }
        }
        .field-box {
            width: 50%;
            box-sizing: border-box;
            padding: 120px 48px;
            background: #fff;
            form {
                width: 100%;
            }
            .logo-box {
                width: 240px;
                margin: 0 auto;
            }
            .input-box {
                width: 100%;
                margin-top: 40px;
                gap: 8px;
                input {
                    border: 1px solid ${(props) => props.theme.borderColor};
                    width: 100%;
                    font-size: 14px;
                    padding: 16px;
                    box-sizing: border-box;
                    background: #fff;
                    color: ${(props) => props.theme.inputColor};
                    border-radius: 4px;
                    &::placeholder {
                        color: ${(props) => props.theme.inputPlaceholderColor};
                    }
                }
            }
            .log-btn {
                width: 100%;
                padding: 16px 0;
                border-radius: 4px;
                background: ${(props) => props.theme.mainColor1};
                color: #fff;
                text-align: center;
                font-size: 16px;
                margin-top: 24px;
            }
            .btn-box {
                margin-top: 8px;
                gap: 6px;
                button {
                    font-size: 12px;
                    color: #777;
                }
                .line {
                    width: 1px;
                    height: 12px;
                    background: ${(props) => props.theme.borderColor};
                }
            }
        }
    }
`